import { createFileRoute, redirect } from "@tanstack/react-router";

import { isLobbyDemoMode, redirectIfUserIsAuthenticated } from "app/lib/helpers";
import { loadAuthEndpoints, loadLobbyConfig } from "app/lib/loaders";
import { SignInPage } from "pages/sign-in";

export const Route = createFileRoute("/sign-in")({
  component: SignInPage,
  onError: console.error,
  beforeLoad: async () => {
    await redirectIfUserIsAuthenticated("/");

    if (isLobbyDemoMode()) {
      throw redirect({
        to: "/casino",
        replace: true,
        search: {
          modal: "log-in",
        },
      });
    }
  },
  loader: () => Promise.all([loadLobbyConfig(), loadAuthEndpoints()]),
});
